// @ts-strict-ignore
import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ProjectModel } from '@project/model/project.model';
import { ProjectStatesDef } from '@project/components/project/constants/project-states-def';
import { ProjectNavigationPresenter } from '@project-navigation/project-navigation.presenter';
import { ProjectComponentPresenter } from '../../project-component.presenter';

export enum QuoteType {
  single,
  multiple
}

@Component({
  standalone: false,
  selector: 'app-project-request-quote-type',
  templateUrl: './project-request-quote-type.component.html'
})
export class ProjectRequestQuoteTypeComponent implements OnInit {

  public readonly types: QuoteType[] = [QuoteType.single, QuoteType.multiple];
  public selectedQuoteType: QuoteType;
  public currentProjectIsRequested: boolean;

  constructor(
    private _bsModalRef: BsModalRef,
    private projectModel: ProjectModel,
    private projectNavigationPresenter: ProjectNavigationPresenter,
    private projectComponentPresenter: ProjectComponentPresenter,
  ) {}

  public ngOnInit(): void {
    this.currentProjectIsRequested = this.projectModel.currentProject.finalizationState === ProjectStatesDef.FINALIZATION_STATE_REQUESTED;
    this.selectedQuoteType = this.currentProjectIsRequested ? QuoteType.multiple : QuoteType.single;
  }

  public close(): void {
    this._bsModalRef.hide();
  }

  public next(): void {
    this.close();
    switch (this.selectedQuoteType) {
      case QuoteType.single:
        this.projectComponentPresenter.openProjectRequestApprovalDialog();
        break;
      case QuoteType.multiple:
        this.projectNavigationPresenter.openRequestMultipleQuoteDialog();
        break;
    }
  }

}
